import React, { Component, useEffect } from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ScriptableContext,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { useApplicationStore } from '../../stores/applicationStore';
import moment from 'moment';
import { useTranslation } from 'react-i18next';


ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  scales: {
    x: {
      display: false,
      grid: {
        display: false,
      }
    },
    y: {
      display: false,
      grid: {
        display: false,
      },
    }
  },
  plugins: {
    subtitle: {
      display: false
    },
    legend: {
      display: false
    },
    title: {
      display: false,
      // text: 'Chart.js Bar Chart',
    },
    tooltip: {
      enabled: true
    }

  },
};


const ChartApprovedApplications: React.FC = () => {
  const applicationStore = useApplicationStore();
  const labels = Array.from({ length: 12 }, (_, i) => moment().subtract(i, 'months').format('MMM')).reverse();
  const [data, setData] = React.useState<{ labels: string[], datasets: { label: string, data: number[], fill: boolean, borderColor: string, backgroundColor: string | ((context: ScriptableContext<"line">) => CanvasGradient), tension: number, borderWidth: number, pointRadius: number, pointHoverRadius: number }[] }>({ labels: [], datasets: [] });
  const { t } = useTranslation(); // useTranslation hook'unu kullanarak 't' fonksiyonuna eriş

  useEffect(() => {
    const numberOfApplications = labels.map(label => applicationStore.applications.filter(application => moment(application.createdAt).format('MMM') === label && application.status === 'visa_approved').length);
    const data = {
      labels,
      datasets: [
        {
          label: t('approvals'),
          data: numberOfApplications,
          borderColor: 'rgb(75, 192, 192)',
          backgroundColor: (context: ScriptableContext<"line">) => {
            const ctx = context.chart.ctx;
            const gradient = ctx.createLinearGradient(0, 0, 0, 220);
            gradient.addColorStop(0, "#14b498");
            gradient.addColorStop(1, "#17897900");
            return gradient;
          },
          tension: 0.1,
          fill: true,
          lineTension: 0.5,
          borderWidth: 2,
          pointHoverRadius: 4,
          pointRadius: 1,
        },
      ],
    };
    setData(data);
  }, [applicationStore.applications]);

  return (
    <div className="card-block card-block-01">
      <div className="d-flex justify-content-between">
        <div className="block-left">
          <h2>{t('approvals')}</h2>
          <p>{t('last30Days')} - <code>{applicationStore.applications.filter(application => moment(application.createdAt).isAfter(moment().subtract(30, 'days')) && application.status === 'visa_approved').length}</code></p>
          <a href="#" className="details-button" title={t('details')}><i className="ti-arrow-circle-right"></i> {t('details')}</a>
        </div>
        <div className="block-right">
          <Line options={options} data={data} />
        </div>
      </div>
    </div>
  );
};

export default ChartApprovedApplications;
